import React, {
  Component,
  Fragment,
  useEffect,
  useState,
  useCallback,
} from 'react';
import { translate } from '../../Services/translation';

const ListViewNonPimItemContainer = (props) => {
  const pro = props.nonPIMItems;
  return (
    <Fragment>
      {props.nonPIMItems.length > 0 && (
        <Fragment>
          <div className="tablediv">
            <table className="pim-table">
              <thead>
                <tr>
                  <th>{translate('product.articlenumber')}</th>
                  <th>{translate('product.category')}</th>
                  <th>{translate('product.description')}</th>
                  <th>{translate('product.producttype')}</th>
                  <th>{translate('product.registernumber')}</th>

                  <th>{translate('product.trailermodel')}</th>
                  <th>{translate('product.year')}</th>

                  <th>{translate('product.generalbOM')}</th>
                </tr>
              </thead>

              <tbody>
                {props.nonPIMItems.map((item, subindex) => (
                  <tr key={"chassi-nonpim-list-tr"+subindex}>
                    <td>{item.ArticleNumber}</td>
                    <td>{item.Category}</td>
                    <td>{item.Description}</td>
                    <td>{item.ProductType}</td>
                    <td>{item.Registernumber}</td>
                    <td>{item.TrailerModel}</td>
                    <td>{item.Year}</td>
                    <td>{item.GeneralBOM}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ListViewNonPimItemContainer;
